import { useNavigate } from 'react-router-dom';

import { ContentNugget, PanelNugget } from '@backrs_ui/common-ui';

import { APP_ROUTE } from '@backrs_ui/grow-ui/src/App';
import { nuggetMapper } from '@backrs_ui/grow-ui/src/components/Nuggets/nugget.util';
import { LubavCollege } from '@backrs_ui/grow-ui/src/models/models';
import { collegeTransform } from '@backrs_ui/grow-ui/src/pages/Search/search.nuggetTransformers';

type Props = Readonly<{
  college: LubavCollege;
}>;

export const CollegeNugget = ({ college }: Props) => {
  const navigate = useNavigate();

  if (!college.id) {
    return null;
  }

  const collegeNugget: ContentNugget = collegeTransform(college.metadata);

  return (
    <PanelNugget
      key={college.id}
      title={collegeNugget.title}
      size="SMALL"
      body={collegeNugget.description}
      variant={nuggetMapper({ nugget: collegeNugget })}
      onClick={() => navigate(`${APP_ROUTE.UNIVERSITY}/${college.id}`)}
      subText={college.relevance}
    />
  );
};
